export default __webpack_public_path__ + "static/media/4.668d7ffe.jpeg";